function processRelativeTimeDe(number, withoutSuffix, key) {
	var format = {
		m: ['eine Minute', 'einer Minute'],
		h: ['eine Stunde', 'einer Stunde'],
		d: ['ein Tag', 'einem Tag'],
		dd: [number + ' Tage', number + ' Tagen'],
		w: ['eine Woche', 'einer Woche'],
		M: ['ein Monat', 'einem Monat'],
		MM: [number + ' Monate', number + ' Monaten'],
		y: ['ein Jahr', 'einem Jahr'],
		yy: [number + ' Jahre', number + ' Jahren'],
	};
	return withoutSuffix ? format[key][0] : format[key][1];
}

export default {
	'nl': {
		months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
			'_'
		),
		monthsShort: 'jan_feb_mrt_apr_mei_jun_jul_aug_sept_okt_nov_dec'.split(
			'_'
		),

		monthsRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
		monthsShortRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
		monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
		monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

		monthsParse: [
			/^jan/i,
			/^feb/i,
			/^maart|mrt.?$/i,
			/^apr/i,
			/^mei$/i,
			/^jun[i.]?$/i,
			/^jul[i.]?$/i,
			/^aug/i,
			/^sep/i,
			/^okt/i,
			/^nov/i,
			/^dec/i,
		],
		longMonthsParse: [
			/^jan/i,
			/^feb/i,
			/^maart|mrt.?$/i,
			/^apr/i,
			/^mei$/i,
			/^jun[i.]?$/i,
			/^jul[i.]?$/i,
			/^aug/i,
			/^sep/i,
			/^okt/i,
			/^nov/i,
			/^dec/i,
		],
		shortMonthsParse: [
			/^jan/i,
			/^feb/i,
			/^maart|mrt.?$/i,
			/^apr/i,
			/^mei$/i,
			/^jun[i.]?$/i,
			/^jul[i.]?$/i,
			/^aug/i,
			/^sep/i,
			/^okt/i,
			/^nov/i,
			/^dec/i,
		],

		weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
			'_'
		),
		weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
		weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
		weekdaysParseExact: true,
		longDateFormat: {
			LT: 'HH:mm',
			LTS: 'HH:mm:ss',
			L: 'DD-MM-YYYY',
			LL: 'D MMMM YYYY',
			LLL: 'D MMMM YYYY HH:mm',
			LLLL: 'dddd D MMMM YYYY HH:mm',
		},
		calendar: {
			sameDay: '[vandaag om] LT',
			nextDay: '[morgen om] LT',
			nextWeek: 'dddd [om] LT',
			lastDay: '[gisteren om] LT',
			lastWeek: '[afgelopen] dddd [om] LT',
			sameElse: 'L',
		},
		relativeTime: {
			future: 'over %s',
			past: '%s geleden',
			s: 'een paar seconden',
			ss: '%d seconden',
			m: 'één minuut',
			mm: '%d minuten',
			h: 'één uur',
			hh: '%d uur',
			d: 'één dag',
			dd: '%d dagen',
			M: 'één maand',
			MM: '%d maanden',
			y: 'één jaar',
			yy: '%d jaar',
		},
		dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
		ordinal: function (number) {
			return (
				number +
				(number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
			);
		},
		week: {
			dow: 1, // Monday is the first day of the week.
			doy: 4, // The week that contains Jan 4th is the first week of the year.
		},
	},
	'fr': {
		months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
			'_'
		),
		monthsShort: 'jan_fév_mar_avr_mai_jun_jul_aoû_sep_oct_nov_déc'.split(
			'_'
		),
		monthsRegex: /(jan\.?|fév\.?|mar|avr\.?|mai|jun|jul\.?|aoû|sep\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
		monthsShortRegex: /(jan\.?|fév\.?|mar|avr\.?|mai|jun|jul\.?|aoû|sep\.?|oct\.?|nov\.?|déc\\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
		monthsStrictRegex: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
		monthsShortStrictRegex: /(jan\.?|fév\.?|mar|avr\.?|mai|jun|jul\.?|aoû|sep\.?|oct\.?|nov\.?|déc\.?)/i,
		monthsParse: [
			/^janv/i,
			/^févr/i,
			/^mars/i,
			/^avr/i,
			/^mai/i,
			/^juin/i,
			/^juil/i,
			/^août/i,
			/^sept/i,
			/^oct/i,
			/^nov/i,
			/^déc/i,
		],
		longMonthsParse: [
			/^janv/i,
			/^févr/i,
			/^mars/i,
			/^avr/i,
			/^mai/i,
			/^juin/i,
			/^juil/i,
			/^août/i,
			/^sept/i,
			/^oct/i,
			/^nov/i,
			/^déc/i,
		],
		shortMonthsParse: [
			/^janv/i,
			/^févr/i,
			/^mars/i,
			/^avr/i,
			/^mai/i,
			/^juin/i,
			/^juil/i,
			/^août/i,
			/^sept/i,
			/^oct/i,
			/^nov/i,
			/^déc/i,
		],
		weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
		weekdaysShort: 'dim_lun_mar_mer_jeu_ven_sam'.split('_'),
		weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
		weekdaysParseExact: true,
		longDateFormat: {
			LT: 'HH:mm',
			LTS: 'HH:mm:ss',
			L: 'DD/MM/YYYY',
			LL: 'D MMMM YYYY',
			LLL: 'D MMMM YYYY HH:mm',
			LLLL: 'dddd D MMMM YYYY HH:mm',
		},
		calendar: {
			sameDay: '[Aujourd’hui à] LT',
			nextDay: '[Demain à] LT',
			nextWeek: 'dddd [à] LT',
			lastDay: '[Hier à] LT',
			lastWeek: 'dddd [dernier à] LT',
			sameElse: 'L',
		},
		relativeTime: {
			future: 'dans %s',
			past: 'il y a %s',
			s: 'quelques secondes',
			ss: '%d secondes',
			m: 'une minute',
			mm: '%d minutes',
			h: 'une heure',
			hh: '%d heures',
			d: 'un jour',
			dd: '%d jours',
			M: 'un mois',
			MM: '%d mois',
			y: 'un an',
			yy: '%d ans',
		},
		dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
		ordinal: function (number, period) {
			switch (period) {
				// TODO: Return 'e' when day of month > 1. Move this case inside
				// block for masculine words below.
				// See https://github.com/moment/moment/issues/3375
				case 'D':
					return number + (number === 1 ? 'er' : '');

				// Words with masculine grammatical gender: mois, trimestre, jour
				default:
				case 'M':
				case 'Q':
				case 'DDD':
				case 'd':
					return number + (number === 1 ? 'er' : 'e');

				// Words with feminine grammatical gender: semaine
				case 'w':
				case 'W':
					return number + (number === 1 ? 're' : 'e');
			}
		},
		week: {
			dow: 1, // Monday is the first day of the week.
			doy: 4, // The week that contains Jan 4th is the first week of the year.
		},
	},
	'zh-cn': {
		// not used since we fallback to zh-hk instead
	},
	'zh-hk': {
		months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
		monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
		weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
		weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
		weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
		longDateFormat: {
			LT: 'HH:mm',
			LTS: 'HH:mm:ss',
			L: 'YYYY/MM/DD',
			LL: 'YYYY年M月D日',
			LLL: 'YYYY年M月D日 HH:mm',
			LLLL: 'YYYY年M月D日dddd HH:mm',
			l: 'YYYY/M/D',
			ll: 'YYYY年M月D日',
			lll: 'YYYY年M月D日 HH:mm',
			llll: 'YYYY年M月D日dddd HH:mm'
		},
		meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
		meridiemHour: function (hour, meridiem) {
			if (hour === 12) {
				hour = 0;
			}
			if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
				return hour;
			} else if (meridiem === '中午') {
				return hour >= 11 ? hour : hour + 12;
			} else if (meridiem === '下午' || meridiem === '晚上') {
				return hour + 12;
			}
		},
		meridiem: function (hour, minute) {
			var hm = hour * 100 + minute;
			if (hm < 600) {
				return '凌晨';
			} else if (hm < 900) {
				return '早上';
			} else if (hm < 1130) {
				return '上午';
			} else if (hm < 1230) {
				return '中午';
			} else if (hm < 1800) {
				return '下午';
			} else {
				return '晚上';
			}
		},
		calendar: {
			sameDay: '[今天]LT',
			nextDay: '[明天]LT',
			nextWeek: '[下]ddddLT',
			lastDay: '[昨天]LT',
			lastWeek: '[上]ddddLT',
			sameElse: 'L'
		},
		dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
		ordinal: function (number, period) {
			switch (period) {
				case 'd' :
				case 'D' :
				case 'DDD' :
					return number + '日';
				case 'M' :
					return number + '月';
				case 'w' :
				case 'W' :
					return number + '週';
				default :
					return number;
			}
		},
		relativeTime: {
			future: '%s內',
			past: '%s前',
			s: '幾秒',
			ss: '%d 秒',
			m: '1 分鐘',
			mm: '%d 分鐘',
			h: '1 小時',
			hh: '%d 小時',
			d: '1 天',
			dd: '%d 天',
			M: '1 個月',
			MM: '%d 個月',
			y: '1 年',
			yy: '%d 年'
		}
	},
	'it': {
		months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
			'_'
		),
		monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
		weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
			'_'
		),
		weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
		weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
		longDateFormat: {
			LT: 'HH:mm',
			LTS: 'HH:mm:ss',
			L: 'DD/MM/YYYY',
			LL: 'D MMMM YYYY',
			LLL: 'D MMMM YYYY HH:mm',
			LLLL: 'dddd D MMMM YYYY HH:mm',
		},
		calendar: {
			sameDay: function () {
				return (
					'[Oggi a' +
					(this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : 'll\'') +
					']LT'
				);
			},
			nextDay: function () {
				return (
					'[Domani a' +
					(this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : 'll\'') +
					']LT'
				);
			},
			nextWeek: function () {
				return (
					'dddd [a' +
					(this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : 'll\'') +
					']LT'
				);
			},
			lastDay: function () {
				return (
					'[Ieri a' +
					(this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : 'll\'') +
					']LT'
				);
			},
			lastWeek: function () {
				switch (this.day()) {
					case 0:
						return (
							'[La scorsa] dddd [a' +
							(this.hours() > 1
								? 'lle '
								: this.hours() === 0
									? ' '
									: 'll\'') +
							']LT'
						);
					default:
						return (
							'[Lo scorso] dddd [a' +
							(this.hours() > 1
								? 'lle '
								: this.hours() === 0
									? ' '
									: 'll\'') +
							']LT'
						);
				}
			},
			sameElse: 'L',
		},
		relativeTime: {
			future: 'tra %s',
			past: '%s fa',
			s: 'alcuni secondi',
			ss: '%d secondi',
			m: 'un minuto',
			mm: '%d minuti',
			h: 'un\'ora',
			hh: '%d ore',
			d: 'un giorno',
			dd: '%d giorni',
			M: 'un mese',
			MM: '%d mesi',
			y: 'un anno',
			yy: '%d anni',
		},
		dayOfMonthOrdinalParse: /\d{1,2}º/,
		ordinal: '%dº',
		week: {
			dow: 1, // Monday is the first day of the week.
			doy: 4, // The week that contains Jan 4th is the first week of the year.
		},
	},
	'da': {
		months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
			'_'
		),
		monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
		weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
		weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
		weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
		longDateFormat: {
			LT: 'HH:mm',
			LTS: 'HH:mm:ss',
			L: 'DD.MM.YYYY',
			LL: 'D. MMMM YYYY',
			LLL: 'D. MMMM YYYY HH:mm',
			LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
		},
		calendar: {
			sameDay: '[i dag kl.] LT',
			nextDay: '[i morgen kl.] LT',
			nextWeek: 'på dddd [kl.] LT',
			lastDay: '[i går kl.] LT',
			lastWeek: '[i] dddd[s kl.] LT',
			sameElse: 'L',
		},
		relativeTime: {
			future: 'om %s',
			past: '%s siden',
			s: 'få sekunder',
			ss: '%d sekunder',
			m: 'et minut',
			mm: '%d minutter',
			h: 'en time',
			hh: '%d timer',
			d: 'en dag',
			dd: '%d dage',
			M: 'en måned',
			MM: '%d måneder',
			y: 'et år',
			yy: '%d år',
		},
		dayOfMonthOrdinalParse: /\d{1,2}\./,
		ordinal: '%d.',
		week: {
			dow: 1, // Monday is the first day of the week.
			doy: 4, // The week that contains Jan 4th is the first week of the year.
		},
	},
	'es': {
		months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
			'_'
		),
		monthsShort: function (m, format) {
			if (!m) {
				return 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
					'_'
				);
			} else if (/-MMM-/.test(format)) {
				return 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_')[m.month()];
			} else {
				return 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
					'_'
				)[m.month()];
			}
		},
		monthsRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
		monthsShortRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
		monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
		monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
		monthsParse: [
			/^ene/i,
			/^feb/i,
			/^mar/i,
			/^abr/i,
			/^may/i,
			/^jun/i,
			/^jul/i,
			/^ago/i,
			/^sep/i,
			/^oct/i,
			/^nov/i,
			/^dic/i,
		],
		longMonthsParse: [
			/^ene/i,
			/^feb/i,
			/^mar/i,
			/^abr/i,
			/^may/i,
			/^jun/i,
			/^jul/i,
			/^ago/i,
			/^sep/i,
			/^oct/i,
			/^nov/i,
			/^dic/i,
		],
		shortMonthsParse: [
			/^ene/i,
			/^feb/i,
			/^mar/i,
			/^abr/i,
			/^may/i,
			/^jun/i,
			/^jul/i,
			/^ago/i,
			/^sep/i,
			/^oct/i,
			/^nov/i,
			/^dic/i,
		],
		weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
		weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
		weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
		weekdaysParseExact: true,
		longDateFormat: {
			LT: 'H:mm',
			LTS: 'H:mm:ss',
			L: 'DD/MM/YYYY',
			LL: 'D [de] MMMM [de] YYYY',
			LLL: 'D [de] MMMM [de] YYYY H:mm',
			LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
		},
		calendar: {
			sameDay: function () {
				return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
			},
			nextDay: function () {
				return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
			},
			nextWeek: function () {
				return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
			},
			lastDay: function () {
				return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
			},
			lastWeek: function () {
				return (
					'[el] dddd [pasado a la' +
					(this.hours() !== 1 ? 's' : '') +
					'] LT'
				);
			},
			sameElse: 'L',
		},
		relativeTime: {
			future: 'en %s',
			past: 'hace %s',
			s: 'unos segundos',
			ss: '%d segundos',
			m: 'un minuto',
			mm: '%d minutos',
			h: 'una hora',
			hh: '%d horas',
			d: 'un día',
			dd: '%d días',
			M: 'un mes',
			MM: '%d meses',
			y: 'un año',
			yy: '%d años',
		},
		dayOfMonthOrdinalParse: /\d{1,2}º/,
		ordinal: '%dº',
		week: {
			dow: 1, // Monday is the first day of the week.
			doy: 4, // The week that contains Jan 4th is the first week of the year.
		},
		invalidDate: 'Fecha invalida',
	},
	'de': {
		months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
			'_'
		),
		monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
			'_'
		),
		monthsParseExact: true,
		weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
			'_'
		),
		weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
		weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
		weekdaysParseExact: true,
		longDateFormat: {
			LT: 'HH:mm',
			LTS: 'HH:mm:ss',
			L: 'DD.MM.YYYY',
			LL: 'D. MMMM YYYY',
			LLL: 'D. MMMM YYYY HH:mm',
			LLLL: 'dddd, D. MMMM YYYY HH:mm',
		},
		calendar: {
			sameDay: '[heute um] LT [Uhr]',
			sameElse: 'L',
			nextDay: '[morgen um] LT [Uhr]',
			nextWeek: 'dddd [um] LT [Uhr]',
			lastDay: '[gestern um] LT [Uhr]',
			lastWeek: '[letzten] dddd [um] LT [Uhr]',
		},
		relativeTime: {
			future: 'in %s',
			past: 'vor %s',
			s: 'ein paar Sekunden',
			ss: '%d Sekunden',
			m: processRelativeTimeDe,
			mm: '%d Minuten',
			h: processRelativeTimeDe,
			hh: '%d Stunden',
			d: processRelativeTimeDe,
			dd: processRelativeTimeDe,
			w: processRelativeTimeDe,
			ww: '%d Wochen',
			M: processRelativeTimeDe,
			MM: processRelativeTimeDe,
			y: processRelativeTimeDe,
			yy: processRelativeTimeDe,
		},
		dayOfMonthOrdinalParse: /\d{1,2}\./,
		ordinal: '%d.',
		week: {
			dow: 1, // Monday is the first day of the week.
			doy: 4, // The week that contains Jan 4th is the first week of the year.
		},
	},
}